import type {
  MBDAttributes,
  MBDParams,
  MBDValue,
} from '@shared/types/frontend/meaningful-behaviour-data';
import type { Common as MBDCommon } from 'trackolding/lib/modern';

type ParamStrategy = (
  key: string,
  value: MBDValue,
  target: MBDCommon,
) => MBDCommon;

const paramStrategies: Record<string, ParamStrategy> = {
  number: (key, value, target) => ({
    ...target,
    numeric_properties: {
      ...(target.numeric_properties || {}),
      [key]: value as number,
    },
  }),
  string: (key, value, target) => ({
    ...target,
    string_properties: {
      ...(target.string_properties || {}),
      // MBD has a limit of 40 characters for string properties
      // If any property exceeds the limit, events for the element will not be sent.
      // Discussion - https://skyscanner.slack.com/archives/C075RJRBB50/p1726667961933649
      [key]: (value as string).slice(0, 40),
    },
  }),
  boolean: (key, value, target) => ({
    ...target,
    boolean_properties: {
      ...(target.boolean_properties || {}),
      [key]: value as boolean,
    },
  }),
};

const generateTrackingAttributes = (
  id: string,
  name: string,
  params?: MBDParams,
): MBDAttributes => {
  let mbdParam: MBDCommon = {
    component_name: name,
  };

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      const strategy = paramStrategies[typeof value];
      if (strategy) {
        mbdParam = strategy(key, value, mbdParam);
      }
    }
  }

  const attributes: MBDAttributes = {
    'data-tracking-element-id': id,
    'data-tracking-common-params': JSON.stringify(mbdParam),
  };

  return attributes;
};

export default generateTrackingAttributes;
